import { oc } from '@orpc/contract';
import { applyDepreciationPresetInputSchema, applyDepreciationPresetOutputSchema } from '../schemas/templates.schemas.js';
/** ADMIN. Writes a preset into the drafts of every active template, or of the chosen ones. Nothing is published. */
export const applyDepreciationPresetContract = oc
    .route({
    method: 'POST',
    path: '/templates/presets/{key}/apply',
    tags: ['Templates'],
    summary: 'Write a starter preset into template drafts',
})
    .input(applyDepreciationPresetInputSchema)
    .output(applyDepreciationPresetOutputSchema);
//# sourceMappingURL=apply-depreciation-preset.contract.js.map